<template>
<v-container fluid class="pa-0">
<!-- Formulaire -->
    <v-card fluid class="ma-2 pa-3 elevation-0 rounded-xxl micorise-v-card">
    <v-card-title >
        Fiche de {{ item.lastName + ' ' + item.firstName }}
        <v-spacer></v-spacer>
        <v-chip outlined color="secondary">
                <v-icon left>mdi-information-outline</v-icon>Modification: {{ $date(item.updatedAt).format('DD MMMM YYYY') }}
        </v-chip>
    </v-card-title>
    <v-layout row wrap class="layout-flex-2" style="">
    <v-flex xs4 class="pa-2">
        <v-text-field outlined dense class="rounded-lg" label="Nom"    v-model="item.lastName" ></v-text-field>
        <v-text-field outlined dense class="rounded-lg" label="Prénom" v-model="item.firstName"></v-text-field>
        <v-text-field outlined dense class="rounded-lg" label="Login"  v-model="item.username"></v-text-field>
        <v-text-field outlined dense class="rounded-lg" label="Mot de passe" type="password" v-model="item.password" loading>
            <template v-slot:progress>
                <v-progress-linear :value="progress" :color="color" height="3" absolute></v-progress-linear>
            </template>
        </v-text-field>
    </v-flex>
    <v-flex xs4 class="pa-2">
        <v-text-field outlined dense class="rounded-lg" label="Tel" v-model="item.phone"></v-text-field>
        <v-text-field outlined dense class="rounded-lg" label="Mobile" v-model="item.mobile"></v-text-field>
        <v-text-field outlined dense class="rounded-lg" label="Courriel" v-model="item.email"></v-text-field>
        <v-select v-if="$root.$permissions?.User?.update" outlined dense class="rounded-lg" :items="roleList" item-value="value" v-model="item.role" label="Role" single-line >
        </v-select>
    </v-flex>
    <v-flex xs4 class="pa-2">
        <v-btn v-if="$root.$permissions?.User?.update"  outlined color="primmary" class="mt-3" @click="resetPasswordMail()">
            <v-icon left>mdi-mail</v-icon>Envoyer le mail
        </v-btn><br />
        <v-btn v-if="$root.$permissions?.User?.update"  outlined color="primmary" class="mt-3" @click="sendMagicLinkToUser()">
            <v-icon left>mdi-cellphone-message</v-icon>Envoyer un lien de connexion
        </v-btn>
    </v-flex>
    <v-flex xs4 class="pa-2"></v-flex>
    <v-flex xs4 class="pa-2">
        <AutocompleteMulti v-if="!loading.fetchData"
            :title="'Mairie'"
            :listObject.sync="item.companyId" :listParent.sync="listCompanies" 
            ressource="companies"
            :fields="{ 
                index: 'cpy_id', text:'cpy_name', autofocus: true, outlined: true, dense: true,
                search:'cpy_name', multiSelect:false, prefetch: false, params:''
        }"></AutocompleteMulti>
    </v-flex>
    </v-layout>
    <v-card-actions>
        <v-btn class="rounded-xl" large color="red" v-if="item.uid" @click="deleteUser(item)"><v-icon title="Supprimer">mdi-delete</v-icon></v-btn>
        <v-spacer></v-spacer>
        <v-btn class="rounded-xl" large color="success" :loading="loading.fetchData" @click.native="saveUser()" :disabled="loading.fetchData">Enregistrer</v-btn>
        <v-btn class="rounded-xl" large color="primmary" href="/#/users/">Retour</v-btn>
    </v-card-actions>
</v-card>
</v-container>
</template>

<script>
import AutocompleteMulti from '@/components/ui/AutocompleteMulti'
import { mapState, mapActions } from 'pinia'
import { useUserStore } from '@/stores/user'
import { cacheGetters } from "@/stores/cache.module"

export default {
    name: 'User-Edit',
    components: { AutocompleteMulti },
    computed: {
        ...mapState(useUserStore, {item: 'item', roleList: 'getRolesArray' }),
        progress () {
            return (this.item.password) ? Math.min(100, this.item.password.length * 12.5) : 0
        },
        color () {
            return ['error', 'warning', 'success'][Math.floor(this.progress / 50)]
        },
    },
    data: function () {
        return {
            loading: { fetchData: true },
            cacheState: cacheGetters.getStates('GEN') || [],
            listCompanies: []
        }
    },
    async mounted () {
        await this.fetchUser( this.$route.params.id, '?include=usercompany' )
        this.listCompanies.push( this.item.usercompany )
        this.loading.fetchData = false
    },
    methods: {
        ...mapActions(useUserStore, {fetchUser: 'fetchItem', updateItem: 'updateItem', storeItem: 'storeItem', resetPassword: 'resetPassword', sendMagicLink: 'sendMagicLink'}),
        async saveUser () {
            // Enregistrement du formulaire
            this.loading.fetchData = true
            if( parseInt( this.$route.params.id ) > 0 ){
                this.updateItem()
            } else {
                this.storeItem()
            }
            this.$router.push('users')
        },
        async resetPasswordMail(){
            await this.resetPassword( this.item.id )
            this.$root.$toast({ color: 'success', text: 'Mail envoyé !' })
        },
        async sendMagicLinkToUser(){
            await this.sendMagicLink( this.item.id )
            this.$root.$toast({ color: 'success', text: 'SMS envoyé !' })
        },
        getCacheType: cacheGetters.getTypes,
    }
}
</script>